export function initCommunication(root) {
  const communication = root?.querySelector('.communication');

  if (!communication) {
    return;
  }

  communication.addEventListener('change', (evt) => {
    window.$analytics?.push('price-communication-method-click', {
      communicationMethod: evt.target.value
    });
  });
}
